import { initialize, Event } from '@harnessio/ff-javascript-client-sdk';
import { Env } from '../utils/env';

export const CHUR_1979_VAT_WEB_SHOPIFY_CART_LOGIC =
  'chur_1979_vat_web_shopify_cart_logic';

class FeatureFlagService {
  private client: ReturnType<typeof initialize> | null = null;
  private initializing: Promise<ReturnType<typeof initialize>> | null = null;
  private evaluationListeners: Array<() => void> = [];

  subscribeToEvaluations(listener: () => void): () => void {
    this.evaluationListeners.push(listener);
    return () => {
      this.evaluationListeners = this.evaluationListeners.filter(
        (fn) => fn !== listener,
      );
    };
  }

  private notifyEvaluationListeners() {
    this.evaluationListeners.forEach((fn) => {
      try {
        fn();
      } catch {
        // ignore listener errors
      }
    });
  }

  async init(identifier: string = 'vat-web-user') {
    if (this.client) return this.client;
    if (this.initializing) return this.initializing;

    const clientKey = Env.REACT_APP_FF_CLIENT_API_KEY;
    if (!clientKey) {
      return Promise.reject(
        new Error('REACT_APP_FF_CLIENT_API_KEY is not configured'),
      );
    }

    this.initializing = new Promise((resolve, reject) => {
      const client = initialize(clientKey, { identifier });

      client.on(Event.READY, () => {
        this.client = client;
        this.notifyEvaluationListeners();
        resolve(client);
      });

      client.on(Event.ERROR, (err: unknown) => {
        reject(err);
      });

      client.on(Event.CHANGED, () => {
        this.notifyEvaluationListeners();
      });
    });

    return this.initializing;
  }

  getFlag(key: string, defaultValue: boolean = false) {
    if (!this.client) return defaultValue;
    return this.client.variation(key, defaultValue);
  }

  isReady(): boolean {
    return this.client != null;
  }
}

const featureFlagService = new FeatureFlagService();

export default featureFlagService;
